import React, { useEffect, useState } from 'react';
import AccodianChecklist from './AccordianChecklist';

const UserTable = (props) => {
  const [cat1, setCat1] = useState(props.category1);
  const [dum, setDum] = useState(false);

  useEffect(() => {
    setCat1(props.category1);
  }, [props]);
  return (
    //alert(JSON.stringify(cat1)),
    <table
      className='table table-bordered table-striped mainGrid'
      style={{ borderCollapse: 'separate', width: '100%' }}
    >
      <thead style={{ background: '#3c8dbc', color: '#fff' }}>
        <tr>
          <th>
            <span>{" Question's"}</span>
            <span style={{ marginLeft: '640px' }}>{' Actions'}</span>
          </th>
        </tr>
      </thead>
      <tbody>
        {cat1.length > 0 && !props.dataEmpty ? (
          cat1.map((user) => (
            <tr key={user.category} className='table-bordered table-striped'>
              <AccodianChecklist
                /* category={user.category.filter(
                    (item, index) => user.category.indexOf(item) !== index
                  )} */
                category={user.category}
                subCategory={user.subCategory}
                editRow={props.editRow}
                accordianNo={props.accordianNo}
                deleteUser={props.deleteUser}
                currentUser={props.currentUser}
                checkName={props.checkName}
              />

              {/* <td>
                <div className="todo-icon">
                  <span
                    className="mx-2 text-success"
                    style={{ cursor: "pointer", marginLeft: "5%" }}
                    onClick={() => {
                      props.editRow(user);

                      
                    }}
                  >
                    <i className="fas fa-pen"></i>
                  </span>
                  <span
                    className="mx-2 text-danger"
                    style={{ cursor: "pointer", marginLeft: "28%" }}
                    onClick={() => props.deleteUser(user.id)}
                  >
                    <i className="fas fa-trash"></i>
                  </span>
                </div>
              </td> */}
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={3}>No Checklist Data</td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default UserTable;
